export default {
	wrapper: {
		paddingLeft: '90px',
		paddingRight: '22px',
		zIndex: '10',
		alignItems: 'flex-end',
	},
	container: {
		marginBottom: '20px',
		alignItems: 'baseline',
	},
	centerSection: {
		alignItems: 'flex-end',
	},
	label: {
		color: '#3c4858',
		fontSize: '18px',
		lineHeight: '21px',
		wordWrap: 'normal',
		marginTop: '20px',
		display: 'inline-block',
	},
	select: {
		padding: '0',
		marginLeft: '20px'
	},
	customerRepSelect: {
		width: '210px',
	},
	callCenterSelect: {
		width: '175px',
	},
	viewSelect: {
		width: '100px',
	},
	navigation: {
		marginLeft: '18px'
	},
	button: {
		height: '26px',
		fontSize: '11px',
		fontWeight: '400',
		marginLeft: '6px',
		padding: '10px 20px',
		'& svg': {
			height: '11px',
		},
	},
	arrowBack: {
		marginLeft: '5px',
	},
	rightButton: {
		color: '#495057',
		height: '25px',
		'& svg': {
			width: '25px',
			height: '25px',
		},
	},
	autocomplete: {
		'& > div': {
			margin: '0',
		},
	},
}
